const Gdpr = () => {

    return (
      <div>
        <h1>Integritetsvilkor</h1>  
      </div>
    );
  };
  
  export default Gdpr;